export default __webpack_public_path__ + "static/media/p7.56d6b310.jpeg";